import React from 'react'
import { useAtom } from 'jotai'
import { Dialog, DialogContent, DialogHeader, DialogTitle, CardButton } from '@duck/ui'
import { ChallengeService } from '@duck/api-definitions'
import { pendingWeaponPickAtom } from '@/store/workspaceAtoms'
import { useTar, TranslationKey } from '@/modules'
import { PostgresIcon } from '../WorkspaceSettings/panels/icons/PostgresIcon'
import { PythonIcon } from '../WorkspaceSettings/panels/icons/PythonIcon'

const WEAPON_ICON: Record<ChallengeService.TaskWeaponsOfChoiceEnum, React.ReactNode> = {
  [ChallengeService.TaskWeaponsOfChoiceEnum.Sql]: <PostgresIcon className="h-10 w-10" />,
  [ChallengeService.TaskWeaponsOfChoiceEnum.Python]: <PythonIcon className="h-10 w-10" />,
}

const WEAPON_LABEL_KEY: Record<ChallengeService.TaskWeaponsOfChoiceEnum, TranslationKey> = {
  [ChallengeService.TaskWeaponsOfChoiceEnum.Sql]: 'common.settingsLanguageSql',
  [ChallengeService.TaskWeaponsOfChoiceEnum.Python]: 'common.settingsLanguagePython',
}

export const PickWeaponDialog = () => {
  const [pending, setPending] = useAtom(pendingWeaponPickAtom)
  const { t } = useTar()

  if (!pending) return null

  const pick = (weapon: ChallengeService.TaskWeaponsOfChoiceEnum) => {
    const cb = pending.onPicked
    setPending(null)
    cb(weapon)
  }

  const cancel = () => {
    const cb = pending.onCancelled
    setPending(null)
    cb()
  }

  return (
    <Dialog open onOpenChange={(open) => !open && cancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('common.pickYourWeapon')}</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-4 py-2">
          {pending.allowedWeapons.map((w) => (
            <CardButton
              key={w}
              icon={WEAPON_ICON[w]}
              title={t(WEAPON_LABEL_KEY[w])}
              onClick={() => pick(w)}
            />
          ))}
        </div>
        <p className="pt-2 text-xs text-muted-foreground">
          {t('common.youCanChangeThisLaterInSettings')}
        </p>
      </DialogContent>
    </Dialog>
  )
}
